import { useState } from 'react';
import apiClient from '@/api/axios';
import { reportLeadConversion } from '@/lib/google-ads';

export const useDemoRequestForm = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const submitDemoRequestForm = async (data) => {
    const { name, email, phone, message, recaptchaToken } = data;

    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await apiClient.post('/landing/demo-req', {
        name,
        email,
        phone,
        message,
        recaptchaToken,
      });

      reportLeadConversion(response.status);
      setSuccess(true);
      setLoading(false);
      return {
        success: true,
        data: response.data,
      };
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'An error occurred';
      setError(errorMessage);
      setLoading(false);
      return {
        success: false,
        error: errorMessage,
      };
    }
  };

  return {
    submitDemoRequestForm,
    loading,
    error,
    success,
  };
};
